import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ChapterBulletList from '@/pages/coleccion-completa-dormir-tranquila/components/ChapterBulletList';
import { libraryObraCompletaCover } from '@/mocks/neurobaby';

export default function ColeccionCompletaDormirTranquila() {
  const { t, i18n } = useTranslation();

  // Checkout de Hotmart segun el idioma de la pagina
  const checkoutUrl =
    i18n.language === 'en'
      ? 'https://pay.hotmart.com/J107376645M'
      : 'https://pay.hotmart.com/H107376600L';

  const coverImage = i18n.language === 'en'
    ? libraryObraCompletaCover.imageEn
    : libraryObraCompletaCover.image;

  return (
    <div className="min-h-screen bg-cream overflow-x-hidden">
      <Navbar />

      {/* Hero */}
      <section className="pt-28 md:pt-36 pb-10 md:pb-14 px-6 md:px-10">
        <div className="w-full max-w-7xl mx-auto text-center">
          <span className="inline-block font-sans text-xs font-semibold text-terracotta uppercase tracking-[0.2em] mb-4">
            {t('coleccion.hero.badge')}
          </span>
          <h1 className="font-serif text-4xl md:text-6xl font-bold text-[#8B6F5C] leading-tight">
            {t('coleccion.hero.title1')}
            <br />
            {t('coleccion.hero.title2')}
          </h1>
          <p className="font-sans text-base md:text-lg text-[#3D2B1F] max-w-2xl mx-auto mt-6 leading-relaxed">
            {t('coleccion.hero.desc')}
          </p>
        </div>
      </section>

      {/* Punteo de capítulos (izquierda) + tapa grande (derecha) */}
      <section className="pb-12 md:pb-16 px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-4 md:gap-6 items-start justify-center">
          {/* Tapa grande — derecha en desktop, arriba en móvil */}
          <div className="lg:order-2 shrink-0 self-start mt-8">
            <div className="w-[380px] max-w-full">
              <div
                data-product-shop
                className="bg-white p-2 rounded-2xl border border-sand/60 overflow-hidden"
              >
                <img
                  src={coverImage}
                  alt={`${t('coleccion.hero.title1')} — ${t('coleccion.hero.title2')}`}
                  className="w-full h-auto object-cover rounded-xl"
                />
              </div>
              <div className="text-center mt-5">
                <div className="flex items-center gap-3 justify-center">
                  <span className="font-sans text-lg text-[#5C4A3A] line-through">$99.90</span>
                  <span className="font-serif text-3xl md:text-4xl font-bold text-terracotta">$79</span>
                  <span className="font-sans text-sm text-[#5C4A3A]">{t('common.usd')}</span>
                </div>
                <p className="font-sans text-xs text-terracotta font-semibold mt-2">
                  {t('coleccion.summary.save')}
                </p>
              </div>
            </div>
          </div>

          {/* Punteo de capítulos */}
          <div className="lg:order-1">
            <div className="mb-6 md:mb-8">
              <h2 className="font-serif text-2xl md:text-3xl font-bold text-[#8B6F5C] leading-tight">
                {t('coleccion.section.title')}
              </h2>
              <p className="font-sans text-sm text-[#3D2B1F] mt-2 max-w-xl">
                {t('coleccion.section.desc')}
              </p>
            </div>
            <ChapterBulletList />
          </div>
        </div>
      </section>

      {/* Botón comprar obra completa */}
      <section className="pb-16 md:pb-24 px-6 md:px-10">
        <div className="w-full max-w-6xl mx-auto flex justify-center">
          <a
            href={checkoutUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-terracotta text-white px-10 py-4 rounded-full font-sans text-base md:text-lg font-semibold hover:bg-brown transition-colors duration-300 whitespace-nowrap cursor-pointer"
          >
            {t('coleccion.buy')}
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}